
import { Component, Vue } from "vue-property-decorator";

const namespace: string = "service";

@Component({
  components: {}
})
export default class ServiceView extends Vue {
  public name: string = "ServiceView";
}
